import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Import the new PWA Install Button component
import InstallApp from './components/InstallApp';

import Home from './pages/Home';
import Search from './pages/Search';
import BusinessDetail from './pages/BusinessDetail';
import { Categories, Cities } from './pages/Directory';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import PaymentResult from './pages/PaymentResult';
import Payments from './pages/Payments';

import AdminLayout from './pages/admin/AdminLayout';
import EmployeeLayout from './pages/employee/EmployeeLayout';
import OwnerLayout from './pages/owner/OwnerLayout';

import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/business/:slug" element={<BusinessDetail />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentResult mode="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
          <Route path="/payments" element={<Payments />} />
          
          <Route path="/admin/*" element={
            <ProtectedRoute roles={['admin','super_admin']}><AdminLayout /></ProtectedRoute>
          } />
          <Route path="/employee/*" element={
            <ProtectedRoute roles={['employee','admin','super_admin']}><EmployeeLayout /></ProtectedRoute>
          } />
          <Route path="/owner/*" element={
            <ProtectedRoute roles={['business_owner','admin','super_admin']}><OwnerLayout /></ProtectedRoute>
          } />

          <Route path="*" element={<div className="container my-5"><h1>404</h1><p>Page not found.</p></div>} />
        </Routes>
        <Footer />
        
        {/* PWA Install Button - Floats at the bottom right when installable */}
        <InstallApp />
        
      </AuthProvider>
    </BrowserRouter>
  );
}